module.exports = __webpack_public_path__ + "img/pay5.8991f3fb.png";